import template from './rw-list-item.html';

export default class RwListItemComponent {
  constructor() {
    this.template = template;
    this.transclude = true;
    this.bindings = {
      noHover: '<',
      noPadding: '<',
      active: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-list/components/rw-list-item-component.js